import { Action, createReducer, on } from "@ngrx/store";
import { EntityUserState, entityUserAdapter, initialState } from "./entity-usuario.state";
import { entityUserLoadRequest, entityUserLoadSuccess } from "./entity-usuarios.actions";

const reducer = createReducer(
  initialState,
  on(entityUserLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityUserLoadSuccess, (state, { items }) =>
    entityUserAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
)

export function entityUserReducer(
  state: EntityUserState | undefined,
  action: Action
) {
  return reducer(state, action)
}
